export default "__VITE_ASSET__UVOBrSf$__";